<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="templeShowDialog"
    width="1000px"
    style="height:500px,max-height:500px"
    center
    :append-to-body="true"
    @open="handleOpen"
    @closed="closeDialog"
    v-drag
  >
    <div class="page">
      <div class="title">{{ getSecond() }}</div>
      <sirui-search
        ref="conditionRef"
        :query="params.spaceDTO"
        :isQueryPanel="false"
        :columns="formColumn"
        :rules="baseRules"
        labelWidth="130px"
        @changeCondition="changeCondition"
      ></sirui-search>
      <FileTable ref="fileTableRef" :attachments="storageAttachment" />
      <div v-if="this.params.spaceDTO != null && this.params.spaceDTO.leafFlag == '0'">
        <div class="title">能耗表</div>
        <el-row style="margin-top: 10px; margin-left: 15px; margin-bottom: 15px">
          <el-button type="primary" @click="addTable('electricity')" class="fixed-bottom-btn"
            >新增电表</el-button
          >
          <el-button type="primary" @click="addTable('water')" class="fixed-bottom-btn"
            >新增水表</el-button
          >
          <el-button type="primary" @click="deleteTable" class="delete">删除</el-button>
        </el-row>
        <vxe-table
          ref="energyTable"
          :data="params.energyDTOList"
          :key="timer"
          border
          align="center"
          header-align="center"
        >
          <vxe-table-column type="checkbox" width="60"></vxe-table-column>
          <vxe-table-column field="energyTypeName" title="水表/电表"></vxe-table-column>
          <vxe-table-column field="energyCode" title="编号"></vxe-table-column>
          <vxe-table-column field="energyMeterTypeName" title="能耗表类型"></vxe-table-column>
        </vxe-table>
      </div>
      <div class="bottom">
        <el-button type="primary" @click="closeDialog" class="btn-cancer">取消</el-button>
        <el-button type="primary" @click="add" :loading="load" class="btn-save">保存</el-button>
      </div>
      <QueryTableDialog
        :showDialog="showQueryTableDialog"
        v-if="showQueryTableDialog"
        :chooseType="chooseType"
        :companyCode="personCompanyCode"
        @chooseData="chooseData($event)"
        :chooseEnergyIds="chooseEnergyIds"
        @closeDialog="showQueryTableDialog = false"
      >
      </QueryTableDialog>
    </div>
  </el-dialog>
</template>
<script>
  import QueryTableDialog from './queryTableDialog.vue';
  import SiruiSearch from '@/components/SiruiSearch';
  import propertyMixin from '../mixins/propertyMixin';
  import { generalFormItem } from '@/api/property/model';
  import { baseRules } from '../rules/rules'; // 校验规则
  import API from '@/api/property/spaceAssets';
  import '@/utils/directives.js';
  export default {
    name: 'UpdatePropertyDialog',
    mixins: [propertyMixin],

    components: {
      QueryTableDialog,
      SiruiSearch,
    },
    computed: {
      propLength() {
        return this.$store.getters.language == 'zh_CN' ? 8 : 14;
      },
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      personCompanyCode: {
        type: String,
        default: '',
      },
      companyList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      currentUpdateId: {
        type: String,
        default: '',
      },
      appendType: {
        type: String,
        default: '',
      },
      // params: {
      //   type: Object,
      //   default: () => {},
      // },
    },
    data() {
      return {
        labelWidth: '120px',
        baseRules: baseRules,
        load: false,
        tableData: [],
        storageAttachment: [],
        templeShowDialog: this.showDialog,
        showQueryTableDialog: false,
        isChangeleafFlag: true,
        defautlEnergyDtoList: [],
        chooseType: '',
        // fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg', 'png'],
        chooseEnergyIds: [],
        timer: '',
        params: JSON.parse(JSON.stringify(generalFormItem)),
      };
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
      'query.location2': {
        handler: function (newVal) {
          if (newVal == '1') {
            console.log(newVal);
          }
        },
        deep: true,
      },
      'params.spaceDTO.attachments': {
        handler: function (newVal) {
          if (newVal != null) {
            this.storageAttachment = this.params.spaceDTO.attachments;
          }
        },
        deep: true,
      },
    },
    mounted() {
      this.params = JSON.parse(JSON.stringify(generalFormItem));

      this.getDetail();
    },

    methods: {
      handleOpen() {
        // this.getDetail();
      },
      async getDetail() {
        const { data } = await this.$axios.get(`${API.SPACE}/${this.currentUpdateId}`);
        if (data.code == 0) {
          if (data.data.space.assetType != null) {
            data.data.space.tempAssetType = data.data.space.assetType.split(',');
          }
          if (data.data.space.selfUseFlag != null) {
            data.data.space.selfUseFlag = data.data.space.selfUseFlag.toString();
          }
          if (data.data.space.selfOwnedFlag != null) {
            data.data.space.selfOwnedFlag = data.data.space.selfOwnedFlag.toString();
          }
          if (data.data.space.leafFlag != null) {
            data.data.space.leafFlag = data.data.space.leafFlag.toString();
          }
          this.params.spaceDTO = data.data.space;
          this.params.energyDTOList = data.data.spaceEnergyList;
          this.defautlEnergyDtoList = data.data.spaceEnergyList;
          console.log('最终数据', this.params);
          this.resetCondition();
          this.storageAttachment = this.params.spaceDTO.attachments;
        }
      },
      closeDialog() {
        this.load = false;
        this.$emit('closeDialog', false);
      },
      uploadHandler(fileObj) {
        this.tableData.push({
          attachmentName: fileObj.attachmentName,
          createBy: fileObj.createBy,
          gmtCreate: new Date(),
          attachmentKey: fileObj.attachmentKey,
          attachmentPath: fileObj.attachmentPath,
        });
      },
      add() {
        this.$refs.conditionRef.validate((value, data) => {
          console.log(data);
          if (!value) {
            return;
          }
          this.load = true;
          if (
            this.params.spaceDTO.tempAssetType != null ||
            this.params.spaceDTO.tempAssetType != undefined
          ) {
            this.params.spaceDTO.assetType = this.params.spaceDTO.tempAssetType.join(',');
          }
          // if (this.$refs.fileTableRef.getTableData().length > 0) {
          this.params.spaceDTO.attachments = this.$refs.fileTableRef.getTableData();
          // }
          this.$axios.post(API.SPACE_UPDATE, this.params).then((res) => {
            if (res.data.code == '0') {
              this.$emit('refreshTree', true);
              this.$message.success('保存成功');
              this.closeDialog();
            } else {
              this.$message.error(res.data.msg);
            }
            this.load = false;
          });
        });
      },

      //新增电表/水表
      addTable(var1) {
        this.chooseType = var1;
        this.chooseEnergyIds = this.params.energyDTOList.map((item) => item.energyId);
        this.showQueryTableDialog = true;
      },
      chooseData(data) {
        let defaultEnergyIds = this.defautlEnergyDtoList.map((item) => item.energyId);
        let chooseEnergyIds3 = data.map((item) => item.energyId);
        chooseEnergyIds3 = chooseEnergyIds3.concat(defaultEnergyIds);
        let tempList = this.params.energyDTOList.filter(
          (item) => chooseEnergyIds3.includes(item.energyId) || item.energyType != this.parseType()
        );
        let chooseEnergyIds2 = this.params.energyDTOList.map((item) => item.energyId);
        let tempAddList = data.filter((item) => {
          let value = chooseEnergyIds2.includes(item.energyId);
          return !value;
        });
        this.params.energyDTOList = [...tempList, ...tempAddList];
      },
      deleteTable() {
        let selectRecords = this.$refs.energyTable.getCheckboxRecords();
        let chooseList = selectRecords.map((item) => item.energyId);
        this.params.energyDTOList = this.params.energyDTOList.filter((item) => {
          return !chooseList.includes(item.energyId);
        });
        this.defautlEnergyDtoList = this.defautlEnergyDtoList.filter((item) => {
          return !chooseList.includes(item.energyId);
        });
        this.timer = new Date().getTime();
      },
      parseType() {
        return this.chooseType == 'electricity' ? '02' : '01';
      },
      changeMethod(val, relatedColumn, method, prop) {
        console.log('changeMethod', val, relatedColumn, method, prop, this.query);
        if (!method) {
          return;
        }
        if (relatedColumn) {
          this.query[relatedColumn] = null;
        }
      },
      clearMethod(val, method) {
        console.log('clearMethod', val, method, this.query);
        if (!method) {
          return;
        }
      },
      getTitle() {
        let arr = { '02': '编辑资产', '03': '编辑单元', '04': '编辑楼层', '05': '编辑房间' };
        return arr[this.appendType];
      },
      getSecond() {
        let arr = {
          '02': '资产信息',
          '03': '单元（楼栋）信息',
          '04': '楼层信息',
          '05': '房间信息',
        };
        return arr[this.appendType];
      },
    },
  };
</script>
<style scoped lang="scss">
  .page {
    overflow: scroll;
    overflow-y: scroll;
    height: calc(100vh - 330px);
  }
  .title {
    font-size: 14px;
    color: black;
    margin-left: 10px;
  }
  .fixed-bottom-btn {
    padding: 0px 0px;
    background-color: #e0e5ff;
    color: #597aff;
    min-width: 60px;
    height: 26px;
    border: 0px solid #dcdfe6;
  }
  .delete {
    padding: 0px 0px;
    background-color: #ff3400;
    color: white;
    min-width: 50px;
    height: 26px;
    border: 0px solid #dcdfe6;
  }
  .bottom {
    margin-top: 20px;
    margin-bottom: 15px;
    text-align: center;
    .btn-cancer {
      padding: 0px 0px;
      background-color: #e0e5ff;
      color: #597aff;
      min-width: 80px;
      height: 30px;
      border: 0px solid #dcdfe6;
    }
    .btn-save {
      padding: 0px 0px;
      background-color: #66b1ff;
      color: white;
      min-width: 80px;
      height: 30px;
      margin-left: 20px;
      border: 0px solid #dcdfe6;
    }
  }
  ::v-deep .el-form-item__label {
    font-size: 12px;
  }
</style>
